import { createSlice } from "@reduxjs/toolkit"

interface UserState {
  usersData: Array<any>
  userProfileData: Array<any>
  selectedUserId: any
  userGroupsDetails: any
}

const initialState: UserState = {
  usersData: [],
  userProfileData: [],
  selectedUserId: null,
  userGroupsDetails: [],
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.usersData = action.payload
    },
    setUserProfileData: (state, action) => {
      state.userProfileData = action.payload
    },
    setSelectedUserId: (state, action) => {
      state.selectedUserId = action.payload
    },
    setUserGroupsDetails: (state, action) => {
      const user = state.usersData.find((user) => user.uid == action.payload)

      state.userGroupsDetails = user?.associated_groups?.groups
    },
  },
})

export default userSlice.reducer
export const { setUserData, setUserProfileData, setSelectedUserId, setUserGroupsDetails } = userSlice.actions
